import React, { useState } from 'react';
const CART_URL = 'https://carlosponte.com/cart/add?id=56937498575173&quantity=1';
const faqs = [{
  question: '¿Cómo recibo el material? ¿Llega a casa?',
  answer: 'Es 100% digital. En menos de 5 minutos después de tu compra recibirás un email con el enlace de descarga. Descargás los PDF, los guardás en tu dispositivo y listo — podés usarlos en consultorio, en la escuela o en casa.'
}, {
  question: '¿Sirve si soy psicóloga o educadora, no terapeuta ocupacional?',
  answer: 'Sí, completamente. El sistema fue diseñado para cualquier profesional que trabaje con niños TEA: terapeutas ocupacionales, psicólogas infantiles, psicopedagogas, educadoras especiales, docentes de apoyo y padres. El lenguaje es accesible y los protocolos aplicables desde cualquiera de estos roles.'
}, {
  question: '¿Hay cuotas o cargos mensuales?',
  answer: 'No. Es un pago único de $17.999 y el acceso es de por vida. Sin renovaciones, sin suscripciones, sin ningún costo adicional. Comprás una vez y el material es tuyo para siempre.'
}, {
  question: '¿Necesito experiencia previa con integración sensorial?',
  answer: 'No es necesario. El sistema está diseñado para que cualquier profesional pueda implementarlo, incluso si nunca trabajaste con enfoque sensorial antes. Cada herramienta incluye instrucciones paso a paso, indicadores claros de cuándo aplicarla y cómo graduar la intensidad.'
}, {
  question: '¿Puedo imprimir el material o solo es digital?',
  answer: 'Podés hacer ambas cosas. El material es tuyo: lo descargás en PDF y decidís si lo usás desde tu tablet, computadora o lo imprimís. Muchos profesionales imprimen las fichas de evaluación y las herramientas que más usan, y mantienen el resto en digital.'
}, {
  question: '¿Funciona para niños de todas las edades?',
  answer: 'El sistema está optimizado para niños de 3 a 12 años, que es el rango donde la intervención sensorial tiene mayor impacto. Las herramientas están graduadas por nivel de desarrollo, no solo por edad cronológica, así que podés adaptarlas al perfil específico de cada niño.'
}, {
  question: '¿Qué pasa si no veo resultados?',
  answer: 'Tenés 60 días de garantía total. Si aplicás las herramientas según los protocolos y no ves mejoras en la estructura de tus sesiones o en la regulación del niño, te devolvemos el 100% de tu inversión. Sin preguntas, sin trámites complicados.'
}, {
  question: '¿Incluye actualizaciones futuras?',
  answer: 'Sí. Cuando comprás el sistema, tenés acceso de por vida. Si agregamos nuevas herramientas, protocolos o recursos en el futuro, los recibirás automáticamente sin costo adicional. Tu inversión de hoy te da acceso permanente a todas las mejoras.'
}];
export function GuaranteeSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="bg-white py-16 px-6" data-id="element-60">
      <div className="max-w-4xl mx-auto" data-id="element-61">
        {/* Guarantee Strip */}
        <div className="flex flex-col md:flex-row items-center gap-7 bg-white border-2 border-brand-green rounded-md p-7 mb-12" data-id="element-62">
          {/* Seal */}
          <div className="flex-shrink-0 w-20 h-20 rounded-full bg-brand-green flex flex-col items-center justify-center text-white" data-id="element-63">
            <span className="font-display font-black text-2xl leading-none" data-id="element-64">
              60
            </span>
            <span className="font-display font-bold text-[10px] uppercase leading-tight text-center" data-id="element-65">
              Días
              <br data-id="element-66" />
              Garantía
            </span>
          </div>

          {/* Text */}
          <div className="text-center md:text-left" data-id="element-67">
            <h3 className="font-display font-black text-xl uppercase text-brand-green-dark mb-2" data-id="element-68">
              Seguridad Profesional: Ámalo o te Devolvemos el 100%
            </h3>
            <p className="text-gray-700 text-base leading-relaxed" data-id="element-69">
              Pruébalo por 60 días completos. Si aplicás las herramientas y no
              ves un cambio real en la estructura de tus sesiones, escribinos y
              te devolvemos cada centavo. Sin trámites. Sin letra chica. Sin
              drama.
            </p>
          </div>
        </div>

        {/* Divider */}
        <hr className="border-t-2 border-gray-200 my-12" data-id="element-70" />

        {/* FAQ Section */}
        <p className="font-display font-extrabold text-xs tracking-[0.18em] uppercase text-brand-green mb-3" data-id="element-71">
          FAQ
        </p>
        <h2 className="font-display font-black text-3xl md:text-4xl uppercase mb-6 text-brand-ink" data-id="element-72">
          Preguntas Frecuentes
        </h2>

        <div className="flex flex-col gap-0.5" data-id="element-73">
          {faqs.map((faq, index) => <div key={index} className="bg-white border border-gray-200 rounded overflow-hidden" data-id="element-74">
              <button onClick={() => toggleFaq(index)} className="w-full flex justify-between items-center px-6 py-5 text-left font-display font-extrabold text-lg uppercase tracking-wide text-brand-ink hover:text-brand-green transition-colors" aria-expanded={openIndex === index} data-id="element-75">
                {faq.question}
                <span className="text-xl transition-transform duration-200" style={{
              transform: openIndex === index ? 'rotate(45deg)' : 'rotate(0deg)'
            }} data-id="element-76">
                  +
                </span>
              </button>
              <div className={`overflow-hidden transition-all duration-300 ${openIndex === index ? 'max-h-48 pb-5' : 'max-h-0'}`} data-id="element-77">
                <p className="px-6 text-base text-gray-500 leading-relaxed" data-id="element-78">
                  {faq.answer}
                </p>
              </div>
            </div>)}
        </div>

        {/* Final CTA */}
        <div className="text-center mt-14" data-id="element-79">
          <a href="https://tododigitalizado.site/checkouts/cn/hWNAFDMBJq2tSDau5BqP6GNG/es-ar?_r=AQABYsDDvKaVTPqGnQqAJ2wodVAATcC181_JPzytgbqUyF0&preview_theme_id=133867339873" onClick={e => {
          e.preventDefault();
          const checkoutUrl = 'https://tododigitalizado.site/checkouts/cn/hWNAFDMBJq2tSDau5BqP6GNG/es-ar?_r=AQABYsDDvKaVTPqGnQqAJ2wodVAATcC181_JPzytgbqUyF0&preview_theme_id=133867339873';
          if (window.fbq) {
            window.fbq('track', 'AddToCart', {
              value: 17.999,
              currency: 'USD',
              content_name: 'Codigo Sensorial TEA',
              content_type: 'product'
            });
          }
          setTimeout(() => {
            window.location.href = checkoutUrl;
          }, 100);
        }} className="inline-block bg-brand-yellow text-brand-ink font-display font-black md:text-2xl uppercase tracking-wider py-5 rounded animate-pulse-btn hover:bg-brand-yellow-dark hover:scale-105 transition-all duration-150 shadow-lg text-[28px] px-[38px] text-center" data-id="element-80">
            QUIERO IMPLEMENTAR EL MÉTODO →
          </a>
          <p className="text-gray-500 text-sm mt-4 font-medium" data-id="element-81">
            PDF Digital · $17.999· Acceso Inmediato · Garantía 60 Días
          </p>
        </div>
      </div>
    </section>;
}